import {Pipe, PipeTransform} from '@angular/core';
import {RouteService} from '../services/route.service';

@Pipe({
    name: 'routeGroupTitle'
})
export class RouteGroupTitlePipe implements PipeTransform {
    constructor(private routeService: RouteService) {}

    transform(id: number): any {
        const routeGroups = this.routeService.getRouteGroup();
        return routeGroups.find((el) => el.id === id) ? routeGroups.find((el) => el.id === id).title : null;
    }
}
